/**
 * Create a function that returns a tick position for the given tick value
 */
export default function getTickPosition(scale) {
  let align = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'center';
  // Broaden type before using 'xxx' in s as typeguard.
  const s = scale;

  // For point or band scales,
  // have to add offset to make the tick at center or end.
  if (align !== 'start' && 'bandwidth' in s) {
    let offset = s.bandwidth();
    if (align === 'center') offset /= 2;
    if (s.round()) offset = Math.round(offset);
    return d => {
      const scaledValue = s(d);
      return typeof scaledValue === 'number' ? scaledValue + offset : scaledValue;
    };
  }
  return scale;
}